/* eslint-disable import/prefer-default-export */

import dayjs from 'dayjs';

/**
 * Changes a month number into the relating month name eg. 1 = Jan
 * dayjs requires a year format so a static year and day are used with the dynamic month
 * @param {Number|String} month - month number that will be changed to it's word form
 * @param {String} format - optional parameter for passing in the date format
 * @returns {String} month name following the given format
 */
export const monthNumberToName = (month, format = 'MMM') => { // eslint-disable-line arrow-body-style
    return dayjs().month(month - 1).format(format);
};
